import GlowingBallTop from "../../assets/learning-tool/learning-tool-top-img.png";
import GlowingBallBot from "../../assets/learning-tool/learning-tool-bot-img.png";
import AntenaTop from "../../assets/learning-tool/learning-tool-right-top-img.png";
import AntenaBot from "../../assets/learning-tool/learning-tool-right-bot-img.png";

const ImageBackground = () => {
  return (
    <>
      <img
        src={GlowingBallTop}
        style={{
          position: "fixed",
          left: "28px",
          top: "180px",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
      />
      <img
        src={GlowingBallBot}
        style={{
          position: "fixed",
          left: "18px",
          top: "400px",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
      />
      <img
        src={AntenaTop}
        style={{
          position: "fixed",
          right: "0",
          bottom: "0",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
      />
      <img
        src={AntenaBot}
        style={{
          position: "fixed",
          right: "8px",
          bottom: "0",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
      />
    </>
  );
};

export default ImageBackground;
